import { Input } from "@/components/ui/input";
import React, { ChangeEvent, CSSProperties, ReactNode, useId } from "react";
import styled from "styled-components";
import { twMerge } from "tailwind-merge";

interface IProps {
  value;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  title?: ReactNode;
  placeholder?: string;
  error?: string;
  required?: boolean;
  className?: string;
  classNameInput?: string;
  disabled?: boolean;
  type?: string;
  style?: CSSProperties;
  suffix?: ReactNode;
  classNameTitle?: string;
  showCount?: boolean;
  maxLength?: number;
  addonBefore?: ReactNode;
  formatter?: (
    value: number | string,
    info: { userTyping: boolean; input: string }
  ) => string;
  parser?: (v: string) => number;
  pattern?: string;
  onFocus?: () => void;
  onBlur?: () => void;
}

const StyledInput = styled(Input)`
  margin-top: 0px !important;
  height: 48px;

  &:focus-visible {
    --tw-ring-color: white;
    border-color: #ff8100;
  }
`;

export function BaseInput(props: IProps) {
  const {
    value,
    onChange,
    title = "",
    placeholder,
    required = false,
    error,
    className,
    type = "text",
    classNameInput = "",
    classNameTitle = "",
    showCount = false,
    maxLength,
    ...prop
  } = props;

  const id = useId();

  return (
    <div>
      {title && (
        <label
          id={id}
          className={twMerge(
            "text-sm text-[#1C125F] mb-2 block",
            classNameTitle
          )}
        >
          {title} {required && <span className="text-error">*</span>}
        </label>
      )}
      <StyledInput
        id={id}
        name={id}
        value={value}
        type={type}
        onChange={onChange}
        className={twMerge(
          "rounded-md text-base text-main placeholder:font-normal",
          classNameInput
        )}
        placeholder={placeholder}
        {...prop}
      />
      {error && (
        <span className="text-error text-[12px] md:text-sm">{error}</span>
      )}
    </div>
  );
}
